import { useHttpClient } from '@/api/httpClient.js';

const resource = 'stream';

export function fetchInformation() {
	return useHttpClient('v2').get(`/${resource}`);
}

export function launchSimulation({ sortitionId, apiToken }) {
	const headers = apiToken
		? {
				'X-API-Token': apiToken
		  }
		: {};
	return useHttpClient('v2').post(
		`/${resource}/launch`,
		{ sortitionId },
		{
			headers
		}
	);
}
